
import { GetIntermediaryExternalResponseDto, GetTaxpayerIntermediariesResponseDto } from '../Service/proxy';

export const LOAD_INTERMEDIARIES_LIST = 'LOAD_INTERMEDIARIES_LIST';
export const LOAD_TAXPAYER_INTERMEDIARIES = 'LOAD_TAXPAYER_INTERMEDIARIES';
export const LoadCurrentIntermediary = 'LoadCurrentIntermediary';
export const intermediariesCurrentApplication = 'Intermediaries_Current_Application';
export const intermediariesCurrentContactDetails = 'Intermediaries_Current_Contact_Details';
export const validationOTPcode = 'Validation_OTPcode';
export const getIntermediariesCurrent = 'Get_Intermediaries_Current';
export const getRepresentationsCurrent = 'getRepresentationsCurrent';
export const representationsCurrent = 'Representations_Current';
export const changeAppStatus = 'ChangeAppStatus';
export const ADD_INTERMEDIARY = 'ADD_INTERMEDIARY';

export interface ChangeAppStatus {
    type: typeof changeAppStatus;
    payload: {
        IsRenew: boolean;
    };
}   


export interface LoadIntermediariesAction {
    type: typeof LOAD_INTERMEDIARIES_LIST;
    payload: GetIntermediaryExternalResponseDto;    
}

export interface LoadTaxpayerIntermediariesAction {
    type: typeof LOAD_TAXPAYER_INTERMEDIARIES;
    payload: GetTaxpayerIntermediariesResponseDto;    
}

export interface LoadCurrentIntermediaryAction {
    type: typeof LoadCurrentIntermediary;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export interface CreateCurrentApplication {
    type: typeof intermediariesCurrentApplication;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export interface CreateCurrentContactDetails {
    type: typeof intermediariesCurrentContactDetails;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export interface CreateValidationOTPcode {
    type: typeof validationOTPcode;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export interface GetIntermediariesCurrent {
    type: typeof getIntermediariesCurrent;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export interface GetRepresentationsCurrent {
    type: typeof getRepresentationsCurrent;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export interface CreateRepresentationsCurrent {
    type: typeof ADD_INTERMEDIARY;
    payload: GetTaxpayerIntermediariesResponseDto;   
}

export type IntermediaryActionTypes =
    | LoadIntermediariesAction
    | LoadTaxpayerIntermediariesAction
    | LoadCurrentIntermediaryAction
    | CreateCurrentApplication
    | CreateCurrentContactDetails
    | CreateValidationOTPcode
    | GetIntermediariesCurrent
    | GetRepresentationsCurrent
    | CreateRepresentationsCurrent
    |ChangeAppStatus
    